<template>
  <div class="chinese">
    <web-header language="cn" ref="webHeaderRef" @account-session-change="$refs.mailSubscription && $refs.mailSubscription.refreshSubscription()"></web-header>
    <div class="chinese-wrap">
      <div class="chinese-wrap-head">
        <div class="chinese-wrap-head-classify">
          <div class="chinese-wrap-head-classify-tab">
            <div v-for="(item, index) in navigateList" @click="changeNav(item)" :class="{ 'chinese-wrap-head-classify-tab-cell': true, 'active': selectNav == item.id }" :key="index">
              {{ item.name }}
            </div>
          </div>
          <div class="chinese-wrap-head-classify-small" v-if="selectNav == 1">
            <div v-for="(item, index) in reportClass" @click="changeClass(item.id)" :class="{ 'chinese-wrap-head-classify-small-cell': true, 'active': selectedClass == item.id }" :key="index">
              {{ item.class_name }}
            </div>
          </div>
          <div class="chinese-wrap-head-classify-small" v-if="selectNav == 2">
            <div v-for="(item, index) in activityClass" @click="changeClass(item.id)" :class="{ 'chinese-wrap-head-classify-small-cell': true, 'active': selectedClass == item.id }" :key="index">
              {{ item.class_name }}
            </div>
          </div>
        </div>
        <div class="chinese-wrap-head-services">
          <institution-trial-entry language="chinese" />
        </div>
      </div>
      <div class="chinese-wrap-content">
        <div class="chinese-wrap-content-left" v-loading="loading">
          <report-cell :list="dataList" v-if="selectNav <= 1"></report-cell>
          <activity-cell :list="dataList" v-if="selectNav == 2"></activity-cell>
          <el-empty :description="loading ? '加载中...' : '暂无数据'" v-if="!dataList || dataList.length == 0"></el-empty>
        </div>
        <div class="chinese-wrap-content-page">
          <el-button type="danger" size="medium" round @click="dataMore" v-if="!noneMore && page.total > page.pageSize">查看更多</el-button>
          <div class="none-more" v-else>没有更多了</div>
        </div>
        <div class="chinese-wrap-content-right">
          <div class="chinese-wrap-content-right-card" v-if="reportSubject && reportSubject.length > 0">
            <div class="chinese-wrap-content-right-card-title">
              热点推荐
            </div>
            <swiper :options="swiperOptions" class="carousel-swiper" ref="carouselSwiper">
              <template v-for="(item, index) in reportSubject">
                <swiper-slide :key="index" v-if="item.image && item.image.img">
                  <a :href="handleCarouseLinks(item)" target="_blank">
                    <img :src="item.image.img"/>
                  </a>
                </swiper-slide>
              </template>
              <template v-if="reportSubject && reportSubject.length > 1">
                <div class="swiper-button-prev carousel-recommend-prev" slot="button-prev"></div>
                <div class="swiper-button-next carousel-recommend-next" slot="button-next"></div>
                <div class="swiper-pagination" slot="pagination"></div>
              </template>
            </swiper>
          </div>
          <div class="chinese-wrap-content-right-card" v-if="activityHots && activityHots.length > 0">
            <div class="chinese-wrap-content-right-card-title">
              近期活动
            </div>
            <swiper :options="swiperActivityOptions" class="carousel-swiper" ref="activitySwiperRef">
              <template v-for="(item, index) in activityHots">
                <swiper-slide :key="index" v-if="item.image && item.image.img">
                  <a :href="handleCarouseLinks(item)" target="_blank">
                    <img :src="item.image.img"/>
                  </a>
                </swiper-slide>
              </template>
              <template v-if="activityHots && activityHots.length > 1">
                <div class="swiper-button-prev carousel-prev" slot="button-prev"></div>
                <div class="swiper-button-next carousel-next" slot="button-next"></div>
                <div class="swiper-pagination" slot="pagination"></div>
              </template>
            </swiper>
          </div>
          <div class="chinese-wrap-content-right-card">
            <div class="chinese-wrap-content-right-card-title">
              关于我们
            </div>
            <div class="chinese-wrap-content-right-card-opera" v-if="singleList && singleList.length > 0">
              <a v-for="(item, index) in singleList" :href="item.link_url ? item.link_url : '/single/chinese/'+item.id" target="_blank" :key="index">{{ item.title }}</a>
            </div>
            <div class="chinese-wrap-content-right-card-desc">
              CF40研究是由中国金融四十人研究院推出的原创研究产品，覆盖研究报告、视听服务、主题会议交流、系列会员活动、多种定制服务等系列。依托中国金融四十人论坛与中国金融四十人研究院，CF40研究围绕宏观经济、政策动向、金融市场、国际问题等领域持续提供独立研究洞见，研究成果触达全球百余家头部金融机构。
            </div>
          </div>
          <div class="chinese-wrap-content-right-card">
            <div class="chinese-wrap-content-right-card-title">
              联系我们
            </div>
            <div class="chinese-wrap-content-right-card-desc">
              <p>
                <span>邮箱：</span>
                <a href="mailto:cf40research@cf40.org.cn">cf40research@cf40.org.cn</a>
              </p>
            </div>
          </div>
          
          <!-- <div class="chinese-wrap-content-right-card">
            <div class="chinese-wrap-content-right-card-icon">
              <div class="qrcode">
                <img src="~@/assets/qr_code.jpg" />
              </div>
            </div>
          </div> -->
          <div class="chinese-wrap-content-right-card">
            <div class="chinese-wrap-content-right-card-title">
              扫码下载APP
            </div>
            <div class="chinese-wrap-content-right-card-desc">
              <div class="flex-box">
                <div class="flex-item" @click="downloadApp('Android')">
                  <img class="qrcode" src="~@/assets/qrcode-android.svg" alt="">
                  <div class="text">
                    <div class="download-icon"></div>
                    Android
                  </div>
                </div>
                <div class="flex-item" @click="downloadApp('HarmonyOS')">
                  <img class="qrcode" src="~@/assets/qrcode-harmony.svg" alt="">
                  <div class="text">
                    <div class="download-icon"></div>
                    HarmonyOS
                  </div>
                </div>
                <div class="flex-item" @click="downloadApp('IOS')">
                  <img class="qrcode" src="~@/assets/qrcode-ios.svg" alt="">
                  <div class="text">
                    <div class="download-icon"></div>
                    IOS
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="chinese-wrap-pagination" style="margin-bottom: 50px" v-if="page.total > page.pageSize">
        <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="page.current"
            :page-size="page.pageSize"
            layout="pager"
            :total="page.total">
        </el-pagination>
      </div>
    </div>
    <article-mail-subscription ref="mailSubscription" language="cn" @visibility-change="isTip = $event" />
    <web-footer language="cn"></web-footer>
    <el-backtop :bottom="isTip ? (isMobile ? 300 : 180) : 60"></el-backtop>
  </div>
</template>

<script>
import { reportList, classifyList, singleNewList, userInfo, carouselList, activityClassList, activityList } from "@/api";
import SwiperMixin from "./swiperMixin";
import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
import WebHeader from "@/components/webHeader";
import InstitutionTrialEntry from "@/components/institutionTrialEntry";
import WebFooter from "@/components/webFooter";
import ArticleMailSubscription from "@/views/report/component/mailSubscription.vue";
import ReportCell from './component/reportCell.vue';
import ActivityCell from './component/activityCell.vue';
export default {
  name: "Chinese",
  mixins: [SwiperMixin],
  components: {
    InstitutionTrialEntry,
    ArticleMailSubscription,
    Swiper,
    SwiperSlide,
    WebHeader,
    WebFooter,
    ReportCell,
    ActivityCell
  },
  data() {
    return {
      keywords: "",
      navigateList: [
        { id: 1, name: "报告", url: "" },
        { id: 2, name: "活动", url: "" }
      ],
      selectNav: 1,
      reportClass: [],
      reportClassStr: "",
      activityClass: [],
      activityClassStr: "",
      selectedClass: 0,
      loading: false,
      dataList: [],
      page: {
        current: 1,
        pageSize: 10,
        orderBy: "publish_time",
        sortedBy: "desc",
        total: 0
      },
      noneMore: false,
      isMobile: false,
      isTip: false, // 根据邮件订阅栏实际显示状态调整返回顶部按钮
      reportSubject: [],
      activityHots: [],
      singleList: [],
      memberInfo: {}
    }
  },
  async created() {
    await this.getClassList();
    await this.getActivityClass();
    await this.getCarousel();
    await this.getSinglePages();
    this.searchData();
  },
  watch: {
    '$route.query.keywords': {
      immediate: false,
      handler() {
        this.searchData();
      }
    }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    downloadApp(type) {
      const map = {
        'Android': 'http://cf40.com/app-release.apk',
        'HarmonyOS': 'https://appgallery.huawei.com/app/detail?id=com.cf40.research.har&channelId=SHARE&source=appshare',
        'IOS': 'https://apps.apple.com/cn/app/cf40/id6757427841'
      }
      window.open(map[type], '_blank');
    },
    searchData() {
      const words = this.$route.query.keywords;
      this.keywords = words ? decodeURIComponent(words) : "";
      this.currentPage = 1;
      if (this.selectNav == 2) {
        this.getActivityList();
      } else {
        this.getReportList();
      }
    },
    async getUserInfo() {
      let token = localStorage.getItem("cf40-token");
      if (token) {
        let res = await userInfo();
        if (res && res.code == 200) {
          this.memberInfo = res.data.user_info;
        }
      }
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    async getSinglePages() {
      let param = {
        pageSize: 30,
        currentPage: 1,
        orderBy: "publish_time",
        sortedBy: "desc",
        search: "status:1|lang:1",
        searchFields: "status:=|lang:="
      };
      let res = await singleNewList(param);
      if (res && res.code == 200) {
        this.singleList = res.data.list;
      }
    },

    async getClassList() {
      this.loading = true;
      let param = {
        pageSize: 50,
        currentPage: 1,
        orderBy: "sort",
        sortedBy: "desc",
        search: "is_show:true|type:1",
        searchFields: "is_show:=|type:=",
      };
      await this.getUserInfo();
      let res = await classifyList(param);
      if (res && res.code == 200) {
        if (res.data && res.data.list && res.data.list.length > 0) {
          let arr = [{id:0, class_name: '最新'}];
          let ids = [];
          for (let i = 0; i < res.data.list.length; i++) {
            let item = res.data.list[i];
            if (!/^[a-zA-Z0-9 ,.'"\-\s]+$/.test(item.class_name)) {
              if (item.class_name == "资讯") {
                if (this.memberInfo.vip_level) {
                  arr.push(item);
                  ids.push(item.id);
                }
              } else {
                arr.push(item);
                ids.push(item.id);
              }
            }
          }
          this.reportClass = arr;
          this.reportClassStr = ids.join();
        }
      }
    },
    async getActivityClass() {
      this.loading = true;
      let param = {
        pageSize: 50,
        currentPage: 1,
        orderBy: "sort",
        sortedBy: "desc",
        search: "lang:1",
        searchFields: "lang:=",
      };
      this.activityClass = [];
      this.activityClassStr = "";
      let res = await activityClassList(param);
      if (res && res.code == 200) {
        if (res.data && res.data.list && res.data.list.length > 0) {
          let arr = [{ id: 0, class_name: '最新' }];
          let ids = [];
          let other = { id: 99999, class_name: '其他', ids:[] }
          for (let i = 0; i < res.data.list.length; i++) {
            let item = res.data.list[i];
            if (item.is_other) {
              other.ids.push(item.id);
            } else {
              arr.push({ id: item.id, class_name: item.class_name, ids: [] });
            }
            ids.push(item.id);
          }
          arr.push(other);
          this.activityClass = arr;
          this.activityClassStr = ids.join();
        }
      }
    },
    async getActivityList() {
      this.loading = true;
      let param = {
        pageSize: this.page.pageSize,
        currentPage: this.page.current,
        orderBy: 'sort',
        sortedBy: 'desc',
        search: "status:1|",
        searchFields: "status:=|",
      };
      if (this.selectedClass == 99999) {
        const allIds = this.activityClass.find(item => item.id === 99999)?.ids;
        if (allIds && allIds.length > 0) {
          param.search = `class_id:${allIds.join()}`;
          param.searchFields = `class_id:${allIds.length > 1 ? 'in' : '='}`;
        }
      } else {
        if (this.selectedClass > 0) {
          param.orderBy = "sort";
          param.sortedBy = "desc";
          param.search = `class_id:${this.selectedClass}`;
          param.searchFields = "class_id:=";
        } else {
          param.orderBy = "activity_start_time";
          param.sortedBy = "desc";
        }
      }
      let res = await activityList(param);
      if (res && res.code == 200) {
        if (this.isMobile) {
          this.dataList = this.dataList.concat(res.data.list);
        } else {
          this.dataList = res.data.list;
        }
        this.page.total = res.data.total;
      }
      this.loading = false;
    },

    async changeNav(e) {
      this.dataList = [];
      this.page.current = 1;
      this.page.total = 0;
      this.selectNav = e.id;
      if (e.id == 0) {
        this.changeClass(e.id);
      } else if (e.id == 1) {
        if (this.reportClass && this.reportClass.length > 0) {
          this.changeClass(this.reportClass[0]['id']);
        }
      } else if(e.id == 2) {
        if (this.activityClass && this.activityClass.length > 0) {
          this.changeClass(this.activityClass[0]['id']);
        }
      }
    },
    changeClass(e) {
      this.selectedClass = e;
      this.currentPage = 1;
      this.dataList = [];
      if (this.selectNav == 2) {
        this.getActivityList();
      } else {
        this.getReportList();
      }
    },
    async getReportList() {
      this.loading = true;
      let param = {
        words: "",
        pageSize: this.page.pageSize,
        currentPage: this.page.current,
        search: "",
        searchFields: "",
        orderBy: this.page.orderBy,
        sortedBy: this.page.sortedBy
      };
      if (this.keywords && this.keywords.length > 0) {
        param.words = this.keywords;
      }
      if (this.selectedClass && this.selectedClass > 0) {
        param.search = `${param.search}product_class_id:${this.selectedClass}`;
        param.searchFields = `${param.searchFields}product_class_id:=`;
      } else {
        param.search = `${param.search}product_class_id:${this.reportClassStr}`;
        param.searchFields = `${param.searchFields}product_class_id:in`;
        param.orderBy = "publish_time";
        param.sortedBy = "desc";
      }
      let res = await reportList(param);
      if (res.code == 200) {
        if (this.isMobile) {
          this.dataList = this.dataList.concat(res.data.list);
        } else {
          this.dataList = res.data.list;
        }
        this.page.total = res.data.total;
      }
      this.loading = false;
    },
    handleCurrentChange(val) {
      this.page.current = val;
      if (this.selectNav == 2) {
        this.getActivityList();
      } else {
        this.getReportList();
      }
    },
    dataMore() {
      if (this.page.total > this.page.current*this.page.pageSize) {
        this.page.current = this.page.current + 1;
        if (this.selectNav == 2) {
          this.getActivityList();
        } else {
          this.getReportList();
        }
      } else {
        this.noneMore = true;
      }
    },
    async getCarousel() {
      let param = {
        pageSize: 20,
        currentPage: 1,
        orderBy: "sort",
        sortedBy: "desc",
        search: "platform_type:2,3",
        searchFields: "platform_type:anyfind",
      };
      let res = await carouselList(param);
      if (res && res.code == 200) {
        this.handleCarouselData(res.data);
      }
    },
    handleCarouselData(rows) {
      if (rows && rows.list && rows.list.length > 0) {
        let subjectArr = [];
        let activityArr = [];
        for (let i = 0; i < rows.list.length; i++) {
          let item = rows.list[i];
          if (item.platform_type.indexOf(2) > -1) {
            subjectArr.push(item);
          } 
          if (item.platform_type.indexOf(3) > -1) {
            activityArr.push(item);
          }
        }
        if (subjectArr && subjectArr.length <= 1) {
          this.swiperOptions.autoplay = false;
          this.swiperOptions.loop = false;
        } else {
          this.swiperOptions.autoplay = true;
          this.swiperOptions.loop = true;
        }
        if (activityArr && activityArr.length <= 1) {
          this.swiperActivityOptions.autoplay = false;
          this.swiperActivityOptions.loop = false;
        } else {
          this.swiperActivityOptions.autoplay = true;
          this.swiperActivityOptions.loop = true;
        }
        this.reportSubject = subjectArr;
        this.activityHots = activityArr;
      }
    },
    handleCarouseLinks(row) {
      let str = "javascript:void(0);";
      if (row && row.url_type) {
        switch(row.url_type) {
          case "1":
          case "2":
          case "3":
            str = row.url_id ? `/report/chinese/${row.url_id}` : "javascript:void(0);";
            break;
          case "6":
            str = row.url_id ? `/activity/chinese/${row.url_id}` : "javascript:void(0);";
            break;
          case "8":
            str = row.url_id ? `/special/chinese/${row.url_id}` : "javascript:void(0);";
            break;
          default:
            str = "javascript:void(0);";
        }
      }
      return str;
    },
    subscribe() {
      this.$refs.webHeaderRef.subscribe();
    },

  }
}
</script>

<style lang="scss" scoped>
.chinese {
  font-family: HarmonyOS_Sans_Regular;
  &-wrap {
    width: 1200px;
    margin: 0 auto;
    &-head {
      margin: 50px 0 20px 0;
      display: flex;
      justify-content: space-between;
      &-classify {
        &-tab {
          flex: 1;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          &-cell {
            color: #ed6f33;
            cursor: pointer;
            font-size: 22px;
            padding-bottom: 5px;
            margin-bottom: 10px;
            margin-right: 40px;
            &:hover, &.active {
              font-family: HarmonyOS_Bold;
              border-bottom: 2px solid #ed6f33;
            }
          }
        }
        &-small {
          margin-top: 30px;
          flex: 1;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          &-cell {
            color: #1E1E1E;
            cursor: pointer;
            padding: 5px 10px;
            font-size: 14px;
            margin-bottom: 10px;
            margin-right: 20px;
            &:hover, &.active {
              border-radius: 3px;
              background-color: #FDF0E9;
            }
          }
        }
      }
      &-services {
        flex: 0 0 400px;
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: 12px;
      }
    }
    &-content {
      display: flex;
      &-left {
        margin-top: 30px;
        flex: 1;
      }
      &-right {
        margin-left: 50px;
        max-width: 400px;
        &-card {
          margin-bottom: 50px;
          &-title {
            font-family: HarmonyOS_Bold;
            color: #757575;
            padding-bottom: 10px;
            border-bottom: 1px solid #e9e9e9;
          }
          .carousel-swiper {
            width: 100%;
            margin-top: 18px;
            ::v-deep {
              .swiper-pagination {
                width: calc(100% - 20px);
                right: 20px;
                text-align: right;
              }
              .swiper-pagination-bullet-active {
                background-color: #ed6f33;
              }
              .swiper-button-prev, .swiper-button-next {
                width: 22px;
                height: 46px;
                color: #ffffff;
                background-color: rgba(0, 0, 0, 0.4);
                &:after {
                  font-size: 14px;
                }
              }
              .swiper-button-prev {
                left: 0;
              }
              .swiper-button-next {
                right: 0;
              }
            }
          }
          &-desc {
            font-size: 12px;
            line-height: 24px;
            color: #808080;
            margin: 15px 0 30px 0;
            p {
              a {
                color: #808080;
                text-decoration: none;
                &:hover {
                  color: #ed6f33;
                }
              }
            }
            .flex-box {
              display: flex;
              .flex-item {
                margin-right: 30px;
                text-align: center;
                .qrcode {
                  padding: 4px;
                  border: 0.5px solid #ccc;
                  border-radius: 8px;
                  width: 82px;
                }
                .text {
                  line-height: 18px;
                  color: #A7A7A7;
                  .download-icon {
                    width: 10px;
                    height: 10px;
                    display: inline-block;
                    background-image: url("../../assets/download-icon-gray.svg");
                    background-size: contain;
                    background-repeat: no-repeat;
                  }
                }
                .text:hover {
                  color: #231816;
                }
              }
              .flex-item:hover {
                margin-right: 30px;
                text-align: center;
                .qrcode {
                  box-shadow: 0px 4px 4px 0px #00000026;
                }
                .text {
                  color: #231816;
                  .download-icon{
                    background-image: url("../../assets/download-icon-black.svg");
                  }
                }
              }
            }
          }
          &-icon {
            display: flex;
            flex-wrap: wrap;
            .qrcode {
              max-width: 120px;
            }
          }
          &-opera {
            a {
              padding: 5px 20px;
              font-size: 12px;
              color: #ed6f33;
              border: 1px solid #ed6f33;
              border-radius: 3px;
              text-decoration: none;
              display: inline-block;
              margin-right: 30px;
              margin-top: 20px;
              &:last-child {
                margin-right: 0;
              }
              &:hover {
                color: #ffffff;
                background-color: #ee8350;
              }
            }
          }
        }
      }
      &-page {
        display: none;
      }
    }
    &-pagination {
      text-align: center;
      margin: 50px 0;
    }
  }
  &-join {
    position: fixed;
    width: 100%;
    bottom: 0;
    color: #ffffff;
    padding: 15px 0;
    text-align: center;
    background-color: #ed6f33;
    z-index: 3000;
    &-describe {
      margin: 0 auto;
      &-header {
        margin-top: 10px;
        font-size: 32px;
        font-family: HarmonyOS_Bold;
      }
      &-tip {
        margin-top: 10px;
        color: #f3f0f0;
      }
      &-btn {
        font-family: HarmonyOS_Bold;
        color: #ed6f33;
        margin-top: 20px;
        cursor: pointer;
        border-radius: 30px;
        padding: 5px 30px;
        user-select: none;
        display: inline-block;
        background-color: #ffffff;
      }
    }
    &-close {
      position: absolute;
      right: 26%;
      top: 15px;
      width: 30px;
      height: 30px;
      border-radius: 30px;
      border: 1px solid #ffffff;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        font-size: 24px;
      }
    }
  }
}
/* 针对平板 */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .chinese {
    &-wrap {
      width: calc(100% - 60px);
      padding: 0 30px;
      &-head {
        margin-top: 30px;
        margin-bottom: 0px;
        flex-direction: column-reverse;
        &-services { flex-basis: auto; width: 100%; }
        &-classify {
          margin-top: 50px;
          &-tab {
            &-cell {
              font-size: 18px;
            }
          }
          &-small {
            &-cell {
              font-size: 14px;
            }
          }

        }
      }
      &-content {
        flex-direction: column;
        &-left {
          margin-top: 30px;
        }
        &-right {
          max-width: 100%;
          margin-left: 0;
        }
        .flex-item {
          margin-right: 20px;
          .qrcode {
            width: 70px;
          }
        }
      }
    }
    &-join {
      &-describe {
        &-header {
          font-size: 28px;
        }
        &-tip, &-btn {
          font-size: 16px;
        }
      }
      &-close {
        right: 10%;
      }
    }
  }
}
/* 针对手机 */
@media screen and (max-width: 767px) {
  .chinese {
    &-wrap {
      width: calc(100% - 60px);
      padding: 0 30px;
      &-head {
        margin-top: 30px;
        flex-direction: column-reverse;
        &-services { flex-basis: auto; width: 100%; }
        &-classify {
          margin-top: 30px;
          &-tab {
            &-cell {
              font-size: 14px;
            }
          }
          &-small {
            &-cell {
              font-size: 12px;
            }
          }

        }
      }
      &-content {
        flex-direction: column;
        &-left {
          margin-top: 10px;
        }
        &-right {
          max-width: 100%;
          min-width: auto;
          margin-left: 0;
        }
        &-page {
          margin: 40px auto 30px auto;
          display: table;
          .none-more {
            font-size: 12px;
            padding: 5px 15px;
            border: 1px solid #DCDFE6;
          }
          ::v-deep {
            .el-button--danger {
              background-color: #ed6f33;
              border-color: #ed6f33;
            }
          }
        }
        .flex-item {
          margin-right: 20px;
          .qrcode {
            width: 70px;
          }
        }
      }
      &-pagination {
        display: none;
      }
    }
    &-join {
      &-describe {
        &-header {
          font-size: 20px;
        }
        &-tip, &-btn {
          font-size: 14px;
        }
      }
      &-close {
        right: 15px;
        width: 20px;
        height: 20px;
        border-radius: 20px;
        i {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
